/**
 * Sub1 Template
 * @category testApp
 */
class AbilityleftcontentsTempl {
    /**
     * Sub1 Templ
     * @param  {Object} _d={}
     * @param  {String} _serverType=''
     */
    static getLeftContentsTempl(_d={}, _serverType='') {
        let contentsTempl;
        if(_serverType === 'LIVE'){
            contentsTempl = AbilityleftcontentsTempl.getLiveTempl(_d);
        }
        else{
            contentsTempl = AbilityleftcontentsTempl.getNEOTempl(_d);
            // alert('server type error');
        }
        return `
        ${contentsTempl}    	
        `;
    }

    static getLiveTempl(_d){
        let liveValueArray =
            [
                ['공격력',_d.total.attackPowerValue,''],
                ['대인 공격력',_d.total.pcAttackPowerValue,''],
                ['항마 공격력',_d.total.bossAttackPowerValue,''],
                ['관통',_d.total.attackPierceValue,''],
                ['명중',_d.total.attackHitValue,''],
                ['집중',_d.total.attackConcentrateValue,''],
                ['치명',_d.total.attackCriticalValue,''],
                ['치명피해',_d.total.attackCriticalDamageValue,''],
                ['숙련',_d.total.attackStiffDurationLevel,'단계'],
                ['위협',_d.total.hatePowerRate,'%'],
                ['상태이상피해',_d.total.abnormalAttackPowerValue,''],
                ['공력',_d.total.attackAttributeValue,''],
                ['추가피해',_d.total.attackDamageModifyDiff,''],
                ['봉마 피해','','','ability-contents-title'],
                ['신귀의 힘',_d.benefit.raceType1AttackDamageModifyPercent,'%'],
                ['진룡의 힘', _d.benefit.attributeType1AttackDamageModifyPercent,'%'],
                ['금호의 힘', _d.benefit.attributeType2AttackDamageModifyPercent,'%']
            ];
        let resultValueArray = AbilityleftcontentsTempl.intDot(liveValueArray);
        let AbilityContentsTableList = AbilityleftcontentsTempl.getAbilityContetnsTableList(resultValueArray);

        return `
        <ul class="ability-contetns-table">
            ${AbilityContentsTableList}
        </ul>
    	`;
    }
    static getNEOTempl(_d){
        let neoValueArray =
            [
                ['관통',_d.attackPierce,''],
                ['명중',_d.attackHit,''],
                ['치명',_d.attackCritical,''],
                ['치명피해',_d.attackCriticalDamage,''],
                ['추가피해',_d.attackDamage,''],
                ['상태이상 적중',_d.attackAbnormalHit,''],
                ['상태이상 피해',_d.abnormalAttackPower,''],
                ['집중',_d.attackConcentrate,''],
                ['숙련',_d.attackStiffPercent,'%'],
                ['근성',_d.defendStiffPercent,'%'],
                ['위협',_d.hatePowerPercent,'%']
            ];
        let resultValueArray = AbilityleftcontentsTempl.intDot(neoValueArray);
        let AbilityContentsTableList = AbilityleftcontentsTempl.getAbilityContetnsTableList(resultValueArray);

        return `
        <ul class="ability-contetns-table">
            ${AbilityContentsTableList}
        </ul>
    	`;
    }

    // int 천단위 이상 dot 추가
    static intDot(_valueArray){
        let resultValueArray;
        for(let i=0;i<_valueArray.length;i++){
            for(let j=1;j<_valueArray[i].length;j++){
                if(_valueArray[i][j]>0) _valueArray[i][j] = _valueArray[i][j].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                if(_valueArray[i][1] == undefined) _valueArray[i][j] = '-';
            }
        }
        resultValueArray = _valueArray;

        return resultValueArray;
    }

    // 리스트 능력치 아이템(li) 템플릿
    static getAbilityContetnsTableList(_valueArray){
        let AbilityContentsTableList = ``;
        for(let i=0;i<_valueArray.length;i++){
          if(_valueArray[i][3] == 'ability-contents-title'){
            AbilityContentsTableList += `
                <li class="${_valueArray[i][3]}">
                  <div class="left">${_valueArray[i][0]}</div>
                </li>
              `;
          }else{
            AbilityContentsTableList += `
              <li ${_valueArray[i][3] ? `class="${_valueArray[i][3]}}"`:``}>
                  <div class="ability-contents-th"><em>${_valueArray[i][0]}</em></div>
                  <div class="ability-contents-td"><span>${_valueArray[i][1]}${_valueArray[i][2]}</span></div>
              </li>
            `;
          }
        }
        return AbilityContentsTableList;
    }

} // end of class

export default AbilityleftcontentsTempl;